import React from './vendor/react';
import { createRoot } from './vendor/react-dom-client';
import { App } from './app/App';
import './styles.css';

createRoot(document.getElementById('root')!).render(<App />);
